import { useAppSelector } from 'app/hooks';
import { SubGenre } from 'features/MenuBook/models';
import { memo } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { getListStyle } from '../MenuBookEditorModal';
import MenuRow from '../MenuRow';
import SubMenuGroupRowList from '../SubMenuGroupRowList';

export interface MenuRowListProps {
  genreId: number;
  genreName: string;
  subgenreId: number;
  onSelectedRowChanged: () => void;
}

function MenuRowList({ genreId, genreName, subgenreId, onSelectedRowChanged }: MenuRowListProps) {
  const subgenre = useAppSelector((state) => {
    return state.menuBookEditor.data
      .flatMap((genre) => (genre.id === genreId ? genre.subgenres : []))
      .find((subgenre) => subgenre.id === subgenreId);
  }) as SubGenre;

  const pathId = `${genreId}-${subgenre.id}`;

  return (
    <Droppable droppableId={`subgenre-${pathId}`} type={`menu-${pathId}`}>
      {(provided, snapshot) => (
        <div {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
          {subgenre.menus.map((menu, index) => (
            <MenuRow
              key={`menu-${genreId}-${subgenreId}-${menu.id}`}
              genreId={genreId}
              genreName={genreName}
              subgenreId={subgenre.id}
              subgenreName={subgenre.name}
              menuId={menu.id}
              index={index}
              onSelectedRowChanged={onSelectedRowChanged}
            >
              <SubMenuGroupRowList genreId={genreId} subgenreId={subgenre.id} menuId={menu.id} />
            </MenuRow>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default memo(MenuRowList);
